export default __webpack_public_path__ + "static/media/mesh_macmat_hs.af90e245.png";